import HttpRequest from '@/libs/axios'
import config from '@/config'
let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
let HOST = process.env.VUE_APP_BASE_URL
console.log(HOST)
console.log(process.env)
if(HOST && HOST !== ''){
    baseUrl = HOST
}


const axios = new HttpRequest(baseUrl)
export default axios
